/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import DialogContent from '@mui/material/DialogContent';
import FormControl from '@mui/material/FormControl';

import {images} from '../../../../constants/image';
import {Modal, Select, Button, Input} from '../../../../components';

// style
import {
  Typography,
  StyledIconClose,
  StyledModalTitle,
  StyledModalActions,
  Divider,
} from './ModalFilter.style';

function createData(label: string, value: string) {
  return {
    label,
    value,
  };
}

interface ModalFilterProps {
  visible: boolean;
  onClose?: () => void;
  handleFilter?: () => void;
  handleClean?: () => void;
  valueFilter?: any;
  defaultValueFilter?: any;
  setValueFilter?: (arg0: any) => void;
  deleteSearchParams?: () => void;
  merchants?: any;
  adminRoles?: any;
}

function ModalFilter({
  visible,
  onClose,
  handleFilter,
  handleClean,
  valueFilter,
  defaultValueFilter,
  setValueFilter,
  deleteSearchParams,
  merchants,
  adminRoles,
}: ModalFilterProps) {
  const onChange = (event: any) => {
    const {name, value} = event.target;
    const updatedValueFilter: any = {
      [name]: value,
    };
    if (name === 'type_eq') {
      if (value === '1') {
        updatedValueFilter.ipName_contains = '';
        updatedValueFilter.roleName_contains =
          defaultValueFilter.roleName_contains ?? '';
      } else if (value === '2') {
        updatedValueFilter.ipName_contains =
          defaultValueFilter.ipName_contains ?? '';
        updatedValueFilter.roleName_contains = '';
      } else {
        updatedValueFilter.roleName_contains =
          defaultValueFilter.roleName_contains ?? '';
        updatedValueFilter.ipName_contains =
          defaultValueFilter.ipName_contains ?? '';
      }
    }

    setValueFilter?.((prevState: any) => ({
      ...prevState,
      ...updatedValueFilter,
    }));
  };

  const handleCleanModalForm = () => {
    handleClean?.();
  };

  const getAdminRolesOptions = () =>
    adminRoles?.reduce((acc: any, item: any) => {
      acc.push({label: item.label, value: item.label});
      return acc;
    }, []) || [];

  return (
    <Modal visible={visible} onClose={onClose}>
      <>
        <StyledModalTitle>Portal Users - Filter by</StyledModalTitle>
        <StyledIconClose onClick={onClose}>
          <img src={images.icon_close} />
        </StyledIconClose>
        <Divider variant="middle" />
        <DialogContent>
          <FormControl fullWidth margin="dense">
            <Typography variant="subtitle2" mb={2}>
              Type
            </Typography>
            <Select
              labelId="type_eq"
              displayEmpty
              name="type_eq"
              variant="outlined"
              onChangeSelect={e => onChange(e)}
              value={valueFilter.type_eq}
              placeholder="Select Type"
              size="small"
              selectOptions={[
                createData('Administrator', '1'),
                createData('Merchant', '2'),
              ]}
            />
          </FormControl>
          {valueFilter.type_eq === '1' && (
            <FormControl fullWidth margin="dense">
              <Typography variant="body2" mb={2}>
                Role
              </Typography>
              <Select
                labelId="roleName_contains"
                placeholder="Select role"
                name="roleName_contains"
                displayEmpty
                size="small"
                variant="outlined"
                onChangeSelect={onChange}
                value={valueFilter.roleName_contains}
                selectOptions={getAdminRolesOptions()}
              />
            </FormControl>
          )}
          {valueFilter.type_eq === '2' && (
            <FormControl fullWidth margin="dense">
              <Typography variant="subtitle2" mb={2}>
                Island Partner
              </Typography>
              <Select
                labelId="ipName_contains"
                displayEmpty
                name="ipName_contains"
                variant="outlined"
                onChangeSelect={e => {
                  onChange(e);
                }}
                value={valueFilter.ipName_contains}
                placeholder="Select Island Partner"
                size="small"
                selectOptions={merchants}
              />
            </FormControl>
          )}
          <FormControl fullWidth margin="dense">
            <Typography variant="subtitle2" mb={2}>
              {'Portal User’s Name'}
            </Typography>
            <Input
              type="text"
              name="adminName_contains"
              placeholder="Enter Portal User’s Name"
              size="small"
              variant="outlined"
              value={valueFilter.adminName_contains}
              onChange={e => onChange(e)}
            />
          </FormControl>
          <FormControl fullWidth margin="dense">
            <Typography variant="subtitle2" mb={2}>
              {'Email Address '}
            </Typography>
            <Input
              type="text"
              name="email_contains"
              placeholder="Enter Email Address"
              size="small"
              variant="outlined"
              value={valueFilter.email_contains}
              onChange={e => onChange(e)}
              sx={{
                mb: 0,
              }}
            />
          </FormControl>
          {/* <FormControl fullWidth margin="dense">
            <Typography variant="subtitle2" mb={2}>
              {'Phone Number'}
            </Typography>
            <Input
              type="number"
              name="phoneNumber_contains"
              placeholder="Enter Phone Number"
              size="small"
              variant="outlined"
              value={valueFilter.phoneNumber_contains}
              onChange={e => onChange(e)}
            />
          </FormControl> */}
          <FormControl fullWidth margin="dense">
            <Typography variant="subtitle2" mb={2}>
              Status
            </Typography>
            <Select
              labelId="isFreeze_eq"
              displayEmpty
              name="isFreeze_eq"
              variant="outlined"
              onChangeSelect={e => onChange(e)}
              value={valueFilter.isFreeze_eq}
              placeholder="Select Type"
              size="small"
              selectOptions={[
                createData('Active', 'false'),
                createData('Frozen', 'true'),
              ]}
            />
          </FormControl>
        </DialogContent>
        <Divider variant="middle" />
        <StyledModalActions>
          <div className="btn-action-1">
            <Button variant="text" onClick={handleCleanModalForm}>
              Clear
            </Button>
          </div>
          <div className="btn-action-2">
            <Button
              onClick={handleFilter}
              disabled={
                !valueFilter.adminName_contains &&
                !valueFilter.ipName_contains &&
                !valueFilter.email_contains &&
                !valueFilter.phoneNumber_contains &&
                !valueFilter.type_eq &&
                !valueFilter.isFreeze_eq &&
                !valueFilter.roleName_contains
              }
            >
              Apply Filter
            </Button>
          </div>
        </StyledModalActions>
      </>
    </Modal>
  );
}
export default ModalFilter;
